<template>
    <NuxtLayout name="malt-full-layout">
        <VJoyTemplate>
            <template #template-main>
                <ProfileGone v-if="error.statusCode === 410 || error.statusCode === 404" :error="error" />
                <ErrorPage v-else :error="error" />
            </template>
        </VJoyTemplate>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import type {NuxtError} from '#app';
    import {ErrorPage} from '#components';
    import {useServerSeoMeta, useTranslation} from '#imports';
    import {VJoyTemplate} from '@maltjoy/core-vue';
    import ProfileGone from '~/components/ProfileGone.vue';

    const {t} = useTranslation();

    defineProps<{
        error: NuxtError;
    }>();

    useServerSeoMeta({
        title: t('400.title.page'),
    });
</script>

<style lang="scss" scoped>
    .profile-gone {
        font-size: var(--joy-font-size-primary-600);
    }
</style>
